import axios from "axios";

// API Configuration
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:9999/api";
const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || "token";
const AUTH_SECRET = process.env.REACT_APP_AUTH_SECRET;
const JWT_SECRET = process.env.REACT_APP_JWT_SECRET;
const JWT_EXPIRES_IN = process.env.REACT_APP_JWT_EXPIRES_IN || "24h";
const CORS_ORIGIN =
  process.env.REACT_APP_CORS_ORIGIN || "http://localhost:3000";
const RATE_LIMIT = process.env.REACT_APP_RATE_LIMIT || 100;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log("Request Config:", {
      url: config.url,
      method: config.method,
      headers: config.headers,
      data: config.data,
    });
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log("Response:", {
      status: response.status,
      data: response.data,
      headers: response.headers,
    });
    return response;
  },
  (error) => {
    console.error("Response Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    // Handle common errors here
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export {
  apiClient as default,
  API_BASE_URL,
  TOKEN_KEY,
  AUTH_SECRET,
  JWT_SECRET,
  JWT_EXPIRES_IN,
  CORS_ORIGIN,
  RATE_LIMIT,
};
